import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { useAuth, formatApiError } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-color.png`;
const LOGO_WHITE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-white.png`;
const STREAK_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_kpl-league/artifacts/89377fcc3ef00973_image.png";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setUser(data);
      navigate(data.role === "admin" ? "/admin" : "/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  const forgot = async (event) => {
    event.preventDefault();
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setForgotMsg("If that email is registered, a reset link has been generated.");
    } catch (err) {
      setForgotMsg(formatApiError(err.response?.data?.detail));
    }
  };

  return <div className="auth-wrap">
    <img className="auth-streak" src={STREAK_URL} alt="" aria-hidden="true" />
    <Link className="auth-home" to="/" data-testid="login-back-home"><ArrowLeft size={15} /> BACK TO SITE</Link>
    <div className="auth-card">
      <img className="auth-logo" src={LOGO_URL} alt="KPL logo" />
      <h1>Welcome back.</h1>
      <p className="auth-sub">Log in to your KPL account to save your franchise and follow the league.</p>
      {error && <div className="auth-error" data-testid="login-error">{error}</div>}
      <form onSubmit={submit}>
        <div className="auth-field"><label>Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="login-email-input" /></div>
        <div className="auth-field"><label>Password</label><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" data-testid="login-password-input" /></div>
        <button className="button button-red auth-submit" type="submit" disabled={busy} data-testid="login-submit-button">{busy ? "Logging in…" : "Log in"}</button>
      </form>
      <p className="auth-switch"><button className="linklike" onClick={() => setForgotOpen(!forgotOpen)} data-testid="forgot-password-toggle">Forgot password?</button></p>
      {forgotOpen && <form onSubmit={forgot} className="auth-forgot">
        <button className="button button-outline auth-submit" type="submit" data-testid="forgot-password-submit">Send reset link</button>
        {forgotMsg && <p className="auth-ok" data-testid="forgot-password-message">{forgotMsg}</p>}
      </form>}
      <p className="auth-switch">New to KPL? <Link to="/register" data-testid="go-register-link">Create an account</Link></p>
    </div>
  </div>;
}
